// extracted by mini-css-extract-plugin
export default {"loading":"ChatBot_loading","hidden":"ChatBot_hidden","chatFrame":"ChatBot_chatFrame"};